import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setHasErrored } from '../../redux/errorReducer/errorSlice'
import "./Error.scss"
const Error = () => {
    const dispatch = useDispatch();
    const hasErrored = useSelector(state => state.error.hasErrored);
    const errorMsg = useSelector(state => state.error.errorMsg);
  return (
    <div className={`${hasErrored? "errorWrapper":"hide"}`}>
        <div className="errorContainer">
            <div className="errorImgContainer">
                <img src="./sbError3.svg" alt="error" className="errorImg" />
            </div>
            <span onClick={() => dispatch(setHasErrored(false))} className={`${"close"}`}>&#10006;</span>
            <div className="errorMsg">
                <p>{errorMsg ? errorMsg: "an error occured!"}</p>
            </div>
        </div>
    </div>
  )
}

export default Error